import { render, staticRenderFns } from "./SignalingServers.vue?vue&type=template&id=62515163&scoped=true"
import script from "./SignalingServers.vue?vue&type=script&lang=js"
export * from "./SignalingServers.vue?vue&type=script&lang=js"
import style0 from "./SignalingServers.vue?vue&type=style&index=0&id=62515163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62515163",
  null
  
)

export default component.exports